import React from 'react'

export default {
  afangi: '3c',
  forSale: true,
  viewable: true,
  btnSpan: 4,
  // status: 'planned-allocation',
  // subtitle: 'Fyrirhuguð úthlutun',
  subtitle: '',
  title: 'Áfangi 3C',
  key: 'afangi-3c',
  rect: {
    className: 'bg-primary text-white',
    props: {
      transform: 'translate(2900, 700) scale(0.8)',
      width: 470,
      height: 180,
    },
  },
  path: {
    d: 'M2214.8 716.9 2387.7 363l79.6 13.3.8-2.7 52.2 7.9v-2.3l53.7 8.2v10.2l11.6 1.8 127.7 24.4 564.8 95.3v4.3l7.5 1.7 8.4 2.9 7.4 2.3 7.2 2.7 7.9 3.6 9.3 4.8 6.3-2.8 37.6 26.1 36.3 25.5 37.8 26.6 60.4 42.5 41.2 29.1 21.6 15 42.2 30.2 20.6 14.2 43.1 31.3 36.8 26.5 20.4 16.5 19.5 18 15.6 15.3 12.9 14.7 7.5 7.8 12.8 16.2 14.6 22.5 10.3 18.5 9 19.3 7.1 22 5.7 23 2.4 19.9 2.6 24.6 2.8 23.6 7 72.6 2.2 26 6.8 63.8 4 36.8.8 31-2.6 18.6-4 17.6-6.3 15.6-6.1 13.1-4.7 8.3-112.3-52.3 9.8-15.6 5.8-15.6 3.2-12.2 1.6-13 .5-10.6-.2-6.6-41.9-8.2-533.3-113.4-57.8-11.8-256.1-54.2-177.4-173.5-116-114.1-135.8-8.2z',
  },
  takkamynd: {
    image: {
      src: require('images/lodir/skogarhverfi/cam04.jpg'),
      width: 4000,
      height: 2250,
    },
    list: [
      {
        lod: 'skogarlundur-9',
        d: 'm1684.32 1775.96-176.09-4.01-177.27-4.45-22.63 168.35 15.43 17.68 368.49 8.33 13.61-185.9h-21.54z',
      },
      {
        lod: 'skogarlundur-11',
        d: 'm1978.99 1663.28-28.12 23.94-4.42 3.22-12.14 9-12.93 8.68-13.99 9.16-17.68 9.48-20.08 10.53-25.8 11.25-19.53 6.75-19.36 5.86-23.55 5.79-19.12 3.33-22.14 3.26-34.27 2.43-13.61 185.9 40.5-1.5 40.39-4.29 40.61-7.07 41.73-10.66 36.16-11.73 35.68-13.5 32.95-15.75 31.02-16.23 23.3-14.63 31.55-21.21 23.25-18.22 39.32-35.14-129.72-128.65z',
      },
      {
        lod: 'skogarlundur-12',
        d: 'm954.44 2000.78-25.56-5.79-23.06-7.15-25.07-8.84-22.5-9.08-97.82 158.12 24 10.82 25.93 10.5 25.71 8.68 28.61 7.71 27.86 6.32 24.42 4.5 19.83 3 49.39-173.62-31.74-5.17z',
      },
      {
        lod: 'skogarlundur-13',
        d: 'm2317.13 1576.09-118.93-108.8-120.45 107.46-98.76 88.53 129.72 128.65 209.47-193.98-1.05-21.86z',
      },
      {
        lod: 'skogarlundur-14',
        d: 'm1033.21 2009.96-29.67-2.3-17.36-1.71-49.39 173.62 33.96 3.86 30 1.5 99.94 2.2 28.04-175.1-95.52-2.07z',
      },
      {
        lod: 'skogarlundur-15',
        d: 'm2394.68 1293.31 129.86 112.34 97.87-89.84-129.86-109.52-97.87 87.02z',
      },
      {
        lod: 'skogarlundur-16',
        d: 'm1289.61 2032.84-14.47-17.92-146.41-2.89-28.04 175.1 167.7 3.91 21.22-158.2z',
      },
      {
        lod: 'skogarlundur-17',
        d: 'm2599.43 880.68-1.29-13.26-52.95-.8-2.65 8.51-15.43.16-1.13 3.78-46.82-1.23 8.97 144.51-49.95 43.61 32.52 27.02 6.43 4.34 8.11 4.58 7.88 3.46 9 3.29 9.72 2.17 10.61 1.37 125.35 2.65 13.99-12.38-21.06-221.78h-41.3z',
      },
      {
        lod: 'skogarlundur-18',
        d: 'm1518.63 2020.3-145.45-3.37-20.09 17.84-19.45 157.98 167.47 3.86 17.52-176.31z',
      },
      {
        lod: 'skogarlundur-19',
        d: 'm2527.11 875.29 15.43-.16 2.65-8.51 52.95.8 1.29 13.26h41.3l-20.41-212.79h-39.53l-1.13-13.66-51.75-1.28-2.57 8.19-14.79.49-.68 5.26-44.24-.85 2.82 51.35 7.66 117.54 3.05 42.91 46.82 1.23 1.13-3.78z',
      },
      {
        lod: 'skogarlundur-20',
        d: 'm1670.98 2200.63 9-176.95-161.35-3.38-17.52 176.31 169.87 4.02z',
      },
      {
        lod: 'skogarlundur-21',
        d: 'm2510.55 661.63 14.79-.49 2.57-8.19 51.75 1.28 1.13 13.66h39.53l-22.82-226.93-36.32-1.07-1.07-15.91-49.66-.69-2.52 9.85-13.72-.37-1.33 6-41.31-.61 14.06 227.88 44.24.85.68-5.26z',
      },
      {
        lod: 'skogarlundur-22',
        d: 'm1831.86 2007.39-25.23 5.04-22.02 3.86-23.79 3.37-27.48 2.57-26.68 1.45h-26.68l-9 176.95 64.45.96 40.02-2.25 44.51-4.18 49.67-8.2-37.77-179.57z',
      },
      {
        lod: 'skogarlundur-23',
        d: 'M2578.27 109.09h-60.75l-.54-8.04-86.86-.96-1.37 8.6-34.87.4-.73-11.09-75.85-.88-1.93 11.17h-10.21l-12.13 8.35 6.91 220.42 301.01 5.39-22.68-233.36z',
      },
      {
        lod: 'skogarlundur-24',
        d: 'm1977.89 1956.5-17.35 8.25-18.86 8.04-20.79 8.14-19.93 6.75-21 6.75-18.32 5.57-16.5 4.18-13.28 3.21 37.77 179.57 45.16-10.28 45.64-12.22 44.36-15.42 56.67-23.58-83.57-168.96z',
      },
      {
        lod: 'skogarlundur-26',
        d: 'm2125.48 1858.95-17.92 15.35-15.91 12.69-16.15 11.81-16.23 10.93-17.68 11.57-16.98 10.72-26.36 14.73 91.29 165.54 32.67-16.83 21.11-11.57 20.36-12.43 22.28-14.46 20.9-14.89 18.32-13.18 18-14.14 16.5-14.47-134.2-141.37z',
      },
      {
        lod: 'skogarlundur-28',
        d: 'm2250.84 1741.3-125.36 117.65 134.2 141.37 17.03-15.11 15.59-14.25 22.66-22.17 75.06-73.61-139.18-133.88z',
      },
      {
        lod: 'skogarlundur-30',
        d: 'm2356.83 1641.74-105.99 99.56 139.18 133.88 105.91-103.98-139.1-129.46z',
      },
      {
        lod: 'skogarlundur-32',
        d: 'm2459.29 1545.31-102.46 96.43 139.1 129.46 102.75-100.88-139.39-125.01z',
      },
      {
        lod: 'skogarlundur-34',
        d: 'm2559.41 1451.43-100.12 93.88 139.39 125.01 100.31-98.81-139.58-120.08z',
      },
      {
        lod: 'skogarlundur-36',
        d: 'm2767.58 1295.4-1.32 1.5-45.33-16.52-6.05 14.08-6.59 10.99-6.97 10.5-9.16 10.28-10.71 10.66-10.02 9-28.45 26.57.77 21.46 126.73 107.06 55.45-53.94 9.21-9.54 8.57-9.86 8.47-11.03 8.36-11.36 8.67-13.5 8.15-15.21 7.6-15.75 6.86-17.15-120.19-44.62-4.05-3.62z',
      },
      {
        lod: 'skogarlundur-38',
        d: 'm2901.57 1304.4 2.73-20.81 1.13-25.47-2.73-37.85-6.91-53.04-25.08-176.46h-35.46v-3.81l-54.96-.75-1.4 3.22-74.96-1.11 22.78 215.18 1.97 19.3-.4 25.67-2.42 16.64-4.93 15.27 45.33 16.52 1.32-1.5 4.05 3.62 120.19 44.62 5.73-19.95 4.02-19.29z',
      },
      {
        lod: 'skogarlundur-40',
        d: 'm2780.29 986.21 54.96.75v3.81h35.46l-31.82-231.06-35.84-.53v-5.71l-52.71-1.28-1.85 5.3-69.03-.64 24.47 231.47 74.96 1.11 1.4-3.22z',
      },
      {
        lod: 'skogarlundur-42',
        d: 'm2750.34 752.19 52.71 1.28v5.71l35.84.53-36.08-258.68h-33.75v-6.35l-50.46-.6-1.25 5.3-52.35-.45-12 10.02 26.46 247.9 69.03.64 1.85-5.3z',
      },
      {
        lod: 'skogarlundur-44',
        d: 'm2782.96 341.96-31.9-229.74-40.9-.96-2.17-18.16h-45.72l-2.82 9.16h-14.38l-1.37 7.55-19.92.08-11.01 8.52 22.1 224.44 148.09-.89z',
      },
      {
        lod: 'akralundur-32',
        d: 'm1625.42 1218.89-.72.25c.12 0-20.66 4.74-20.66 4.74s-17.51 3-18.48 3-9.88.88-9.88.88l-156-2.28-17.14 13.5-18.74 138.72 244.27 4.73 16-1.29 16.32-2.73 14.22-3.21-49.18-156.31Z',
      },
      {
        lod: 'akralundur-34',
        d: 'm1812.2 1112.21-22.88-1.07-43.39 34.11-37.18 29.48-14.1 10.78-12 7.92-12.29 7-14.87 7.59s-14.5 5.79-14.66 5.83-12.29 4-15.39 5.05l49.18 156.31 17.52-4.5 13.82-5.39 13.63-6.35 13.07-6.85 12.32-7.93 12.75-9.11 17.79-14.25 21.86-17.78 117.26-96.59Z',
      },
      {
        lod: 'akralundur-36',
        d: 'm2313.84 879.71 37.21-30.37 1.92 1.85 22.58-18.24 100.56 1.98-7.66-117.54-162.96-37.33-.49 1.65-6.11 14.31-8.84 14.62-9.16 11.57-7.39 7.4-14.95 13.02-98.67 77.62v17.2l104.3 85.9 49.66-40.46v-3.18z',
      },
      {
        lod: 'akralundur-38',
        d: 'm2465.63 666.04-14.06-227.88-35.09-.52-.37-6.75-49.88-.97-.64 6.18-61.59-.24 6.79 206-.33 14.14-1.44 12.21-3.53 11.85 162.96 37.33-2.82-51.35z',
      },
      {
        lod: 'akralundur-53',
        d: 'M1689.55 735.63 1492.8 877.46l25.56 25.02 83.68 73.98-18.33 182.79.73-.13 12.13-2.33 13.34-3.38 10.21-3.78 10.93-5.3 8.03-4.82 9.48-6.75 262.56-203.71-221.57-193.42z',
      },
      {
        lod: 'akralundur-57',
        d: 'm2189.93 577.81-246.86-2.17-16.39 1.77-17.52 4.98-13.98 6.43-23.3 16.23-151.08 107.2 178.51 154.27 43.65 37.73 22.88-17.61 251.65-193.68 6.59-6.5 5.87-9.08 4.1-8.2 2.89-7.88 1.28-7.31v-38.01l-48.29-38.17z',
      },
      {
        lod: 'akralundur-59',
        d: 'M2228.82 107.05h-22.71V93.98l-78-.91v12.81l-127.82-2.04V92.05l-98.52-1.28-.48 11.25-114.99-2.01-18.73 227.81 465.59 8.52-4.34-229.29z',
      },
      {
        lod: 'h-17',
        d: 'm2234.71 433.89-322.92-5-5.68 105.75s7.71 16.07 8.25 16.07 16.82-3 16.82-3l14.89-2.57 9.43-1 267.32 4.4 13.39-9.65Z',
      },
      {
        lod: 'h-15',
        d: 'm1798.96 464-204.58 141.59 100.33 88.02 170.58-120.06 9-5.78 10.6-5.47 8.2-3.85 7.39-2.41-9.16-17.84-36.64-28.45-.4-6.19-34.23-27.67-3.65 2.6-17.44-14.49z',
      },
      {
        lod: 'h-13',
        d: 'm1620.84 660.42-.4-3.94-33.27-27.88-2.01 1.2-11.65-10.2-315.56 218.53 67.34 29.85h13.9l1.2 5.31 72.56 31.58 9.57-11.9 9-8.68 11.41-9.8 14.78-10.93 217.53-155.81-54.4-47.33z',
      },
      {
        lod: 'h-11',
        d: 'M1339.19 867.98h-13.9l-67.34-29.85-15.83 10.97-53.55 302.44 156.16 3.69 17.25-13.18 24.78-172.5 2.41-15.26 4.18-13.83 4.82-10.52 6.03-11.01 8.75-14.06-72.56-31.58-1.2-5.31z',
      },
      {
        lod: 'h-9',
        d: 'm1333.96 1223.59-158.3-3.59-22.86 132.09 177.47 3.58 16.98-118.53-13.29-13.55z',
      },
      { lod: 'h-7', d: 'm1330.27 1355.67-177.47-3.58-24.6 138.98 181.9 3.94 20.17-139.34z' },
      { lod: 'h-5', d: 'm1127.07 1497.93-24.21 134.89 186.32 2.89 19.61-133.6-181.72-4.18z' },
      { lod: 'h-3', d: 'm1102.86 1632.82-26.15 149.79 190.72 4.34 21.75-151.24-186.32-2.89z' },
      {
        lod: 'h-2',
        d: 'm1518.36 902.48-52.69 38.71-5.14 4.1-5.47 5.38-4.58 5.46-4.26 5.79-3.85 6.51-3.06 6.75-2.25 9.32-1.85 12.54-20.03 144.42 14.3 15.54 151.82 2.68 2.41-.43 18.33-182.79-83.68-73.98z',
      },
      {
        lod: 'h-1',
        d: 'm1047.57 1946.64 169.39 4.72 30.3-25.64 20.17-138.77-190.72-4.34-29.14 164.03z',
      },
      {
        lod: 'k-12',
        d: 'm2672.82 1216.2-3.64-35.63-25.34-20.57-111.83-2c-.24 0-18.8-1-18.8-1l-2.17 31.9-18.49 17.52 129.86 109.52 14.87-14 11.57-11.33 7.47-8.6 6.35-10.36 4.26-9.89 4-11.57 2.17-12Z',
      },
      {
        lod: 'k-10',
        d: 'm2495.69 1153.17-15.27-4.42-14.87-5.87-14.46-7.71-10.04-6.67-13.35-10.69-.93-.76-117 102.9 84.91 73.36 97.87-87.02 18.49-17.52 2.16-31.9-17.51-3.7z',
      },
      { lod: 'k-8', d: 'm2345.74 1050.31-117.4 99.78 81.43 69.86 117-102.9-81.03-66.74z' },
      { lod: 'k-6', d: 'm2266.51 984.1-117.03 98.06 78.86 67.93 117.4-99.78-79.23-66.21z' },
      { lod: 'k-4', d: 'm2189.39 920.21-116.7 95.31 76.79 66.64 117.03-98.06-77.12-63.89z' },
      {
        lod: 'k-2',
        d: 'm2189.39 920.21-66.69-55.17h-19.72l-106.55 84.26 76.26 66.22 116.7-95.31z',
      },
      {
        lod: 'k-1',
        d: 'm2476.11 834.93-100.56-1.98-22.58 18.24-1.92-1.85-37.21 30.37v3.18l-49.66 40.46 173.57 142.26.43.35 49.95-43.61-8.97-144.51-3.05-42.91z',
      },
      {
        lod: 'j-3',
        d: 'm2243.18 1218.07-123.43 105.32 230.57 209.57 36.97 1.4 104.57-99.22-248.68-217.07z',
      },
      {
        lod: 'j-1',
        d: 'm1964.05 974.94-30.54 22.98-2.65-3.62-41.06 33.51v4.99l-37.69 29.16-1.07 18.86 258.53 234.75 124.29-105.43-269.81-235.2z',
      },
      {
        lod: 'i-1',
        d: 'm1674.6 1375.2-14.22 3.21-16.32 2.73-16 1.29-244.27-4.73-.12.87-20.22 145.85 14.67 15.75s338.25 7.07 338.66 6.91 17.92-1.85 17.92-1.85l12.37-2.65 10-3.54-65-168.34Z',
      },
      {
        lod: 'i-2',
        d: 'm1370.93 1593.85-18.8 15.59-21.17 158.06 177.27 4.45 17.95-174.97-155.25-3.13z',
      },
      {
        lod: 'i-3',
        d: 'm1914.63 1206.45-117.27 96.59-21.86 17.78-17.79 14.25-12.75 9.11-12.32 7.93-13.07 6.85-13.63 6.35-13.82 5.39 65.01 168.35 11.49-4.99 11.08-5.7 11.01-6.91 11.74-8.68 14.54-12.54 206.22-174.59v-19.6l-108.58-99.59z',
      },
      { lod: 'i-4', d: 'm1526.18 1596.98-17.95 174.97 174.48 3.98 14.9-175.25-171.43-3.7z' },
      {
        lod: 'i-6',
        d: 'm1831.32 1559.11-15.53 10.89-18.65 9.21s-20.46 8.68-20.89 9.32-22.29 6.54-22.29 6.54l-21.1 4-17.15 1.61h-18.1l-14.9 175.25h23.15l34.27-2.43 22.14-3.26 19.12-3.33 23.55-5.79 19.36-5.86 19.53-6.75 25.79-11.25 20.09-10.53 17.68-9.48 14-9.16 12.93-8.68 12.14-9Z',
      },
      {
        lod: 'i-8',
        d: 'm1978.99 1663.28 98.76-88.53-124.39-119.6-122.04 103.96 115.13 131.33 4.42-3.22 28.12-23.94z',
      },
      {
        lod: 'i-10',
        d: 'M2084.02 1362.26h-22.18l-108.48 92.89 124.39 119.6 120.45-107.46-114.18-105.03z',
      },
    ],
  },
}
